module.exports = __webpack_public_path__ + "img/pointC_bg.db04581d.png";